

const cardsSlider = jQuery('.featured__cards'),
    cardsSlide = jQuery('.sport__block')

if (cardsSlider.length > 0 && cardsSlide.length > 1) {

    var carousel = cardsSlider.flickity({
        cellSelector: '.sport__block',
        prevNextButtons: true,
        autoPlay: false,
        // pauseAutoPlayOnHover: false,
        // wrapAround: true,
        pageDots: true,
        groupCells: true ,
        // contain: true,
        cellAlign: 'left',
        // lazyLoad: 2,
        draggable: true,
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 45,
            x3: 20
        }
    })

    jQuery(".sport__block").addClass("pageloaded");
    // // previous
    // jQuery('.button--previous').on( 'click', function() {
    //     carousel.flickity('previous');
    // });
    // jQuery('.button--previous').on( 'keypress', function(e) {
    //     if(e.which == 13) {
    //         carousel.flickity('previous');
    //     }
    // });
    // // next
    // jQuery('.button--next').on( 'click', function() {
    //     carousel.flickity('next');
    // });
    // jQuery('.button--next' ).on( 'keypress', function(e) {
    //     if(e.which == 13) {
    //         carousel.flickity('next');
    //     }
    // });
}
